import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessRecentlyCreatedRoute: InvariantJiraRoute = {
	name: 'classic-business-reports-recently-created',
	path: '/jira/core/projects/:projectKey/reports/recently-created',
};
